export const MODAL_EDIT_SHOW = "MODAL_EDIT_SHOW";
export const MODAL_EDIT_HIDE = "MODAL_EDIT_HIDE";

const initialState = {
  showEditModal: false
};

export default function modalReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case MODAL_EDIT_SHOW:
      return payload;

    case MODAL_EDIT_HIDE:
      return payload;

    default:
      return state;
  }
}

export function showEditModal() {
  return {
    type: MODAL_EDIT_SHOW,
    payload: {
      showEditModal: true
    }
  };
}

export function hideEditModal() {
  return {
    type: MODAL_EDIT_HIDE,
    payload: {
      showEditModal: false
    }
  };
}
